import { render, staticRenderFns } from "./EllipsisIcon.vue?vue&type=template&id=0cbefb77&"
import script from "./EllipsisIcon.vue?vue&type=script&lang=js&"
export * from "./EllipsisIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports